export const TemplateOrderService = {
  titulo: "resume.resumeCollapse.title",
  id: "resumeOrder",
  edit: [
    {
      type: "Label",
      label: "resume.resumeCollapse.company",
      class: "col-md-3 input-form",
      placeHolder: "company",
      name: "company",
      id: "CustomerName",
    },
    {
      type: "Label",
      label: "resume.resumeCollapse.creationDate",
      class: "col-md-3 input-form",
      placeHolder: "creationDate",
      name: "creationDate",
      id: "CreateDatePO",
    },
    {
      type: "Label",
      label: "resume.resumeCollapse.destinationDate",
      format: "DD-MM-YYYY",
      name: "destinationDate",
      class: "col-md-3 input-form",
      id: "RequiredDestinationDate",
      placeHolder: "required_at_destination",
      // required: true,
    },
    {
      type: "Label",
      label: "resume.shared.uploadRequest",
      format: "DD-MM-YYYY",
      name: "destinationDate",
      class: "col-md-3 input-form",
      id: "RequiredCargoReadyDate",
      placeHolder: "resume.shared.uploadRequest",
      // required: true,
    },
    {
      type: "Select",
      label: "resume.resumeCollapse.incoterm",
      class: "col-md-3 input-form",
      placeHolder: "resume.resumeCollapse.incoterm",
      name: "incoterm",
      catalogId: "incotermCatalog",
      id: "Incoterms",
    },
    {
      type: "Input",
      label: "resume.resumeCollapse.productType",
      class: "col-md-3 input-form",
      placeHolder: "resume.resumeCollapse.productType",
      name: "productType",
      id: "ProductType",
    },
    // {
    //   type: "Input",
    //   label: "resume.resumeCollapse.poDivision",
    //   class: "col-md-3 input-form",
    //   placeHolder: "resume.resumeCollapse.poDivision",
    //   name: "poDivision",
    //   id: "Division",
    // },
    {
      type: "Input",
      label: "resume.resumeCollapse.originCountry",
      class: "col-md-3 input-form",
      placeHolder: "resume.resumeCollapse.originCountry",
      name: "originCountry",
      id: "POL",
      maxLength: 20,
      required: true,
    },
    {
      type: "Select",
      label: "resume.resumeCollapse.transportMode",
      class: "col-md-3 input-form",
      placeHolder: "resume.resumeCollapse.transportMode",
      name: "transportMode",
      catalogId: "transportModeCatalog",
      id: "TransportMode",
      required: false,
    },
    // {
    //   type: "Input",
    //   label: "resume.resumeCollapse.destinationCountry",
    //   class: "col-md-3 input-form",
    //   placeHolder: "resume.resumeCollapse.destinationCountry",
    //   name: "destinationCountry",
    //   maxLength: 20,
    //   id: "POD",
    // },
    // {
    //   type: "Input",
    //   label: "resume.resumeCollapse.project",
    //   class: "col-md-3 input-form",
    //   placeHolder: "resume.resumeCollapse.project",
    //   name: "project",
    //   id: "Project",
    // },
    // {
    //   type: "Input",
    //   label: "resume.resumeCollapse.wmsReference",
    //   class: "col-md-3 input-form",
    //   placeHolder: "resume.resumeCollapse.wmsReference",
    //   name: "wmsReference",
    //   id: "WMSReference",
    // },
    {
      type: "Input",
      label: "resume.resumeCollapse.clientReference",
      class: "col-md-3 input-form",
      placeHolder: "resume.resumeCollapse.clientReference",
      name: "clientReference",
      id: "CustomerReference",
    },
    {
      type: "Input",
      label: "resume.resumeCollapse.buyer",
      class: "col-md-3 input-form",
      placeHolder: "resume.resumeCollapse.buyer",
      name: "buyer",
      id: "Buyer",
    },
    {
      type: "Checkbox",
      label: "resume.resumeCollapse.priorityPO",
      class: "col-md-3 input-form",
      placeHolder: "resume.resumeCollapse.priorityPO",
      name: "priorityPO",
      id: "PriorityPO",
      disabled: true,
    },
  ],
  previewForm: [
    {
      type: "Label",
      label: "resume.resumeCollapse.company",
      class: "col-md-3 input-form",
      placeHolder: "company",
      name: "company",
      id: "CustomerName",
    },
    {
      type: "Label",
      label: "resume.resumeCollapse.creationDate",
      class: "col-md-3 input-form",
      placeHolder: "creationDate",
      name: "creationDate",
      id: "CreateDatePO",
    },
    {
      type: "Label",
      label: "resume.resumeCollapse.destinationDate",
      format: "DD-MM-YYYY",
      name: "destinationDate",
      class: "col-md-3 input-form",
      id: "RequiredDestinationDate",
    },
    {
      type: "Label",
      label: "resume.shared.uploadRequest",
      name: "uploadRequest",
      format: "DD-MM-YYYY",
      class: "col-md-3 input-form",
      id: "RequiredCargoReadyDate",
    },
    {
      type: "Label",
      label: "resume.resumeCollapse.incoterm",
      class: "col-md-3 input-form",
      placeHolder: "incoterm",
      name: "incoterm",
      id: "Incoterms",
    },
    {
      type: "Label",
      options: "productType",
      label: "resume.resumeCollapse.productType",
      name: "productType",
      class: "col-md-3 input-form",
      id: "ProductType",
    },
    // {
    //   type: "Label",
    //   label: "resume.resumeCollapse.poDivision",
    //   class: "col-md-3 input-form",
    //   placeHolder: "poDivision",
    //   name: "poDivision",
    //   id: "Division",
    // },
    {
      type: "Label",
      options: "originCountry",
      label: "resume.resumeCollapse.originCountry",
      name: "originCountry",
      class: "col-md-3 input-form",
      id: "POL",
    },
    {
      type: "Label",
      label: "resume.resumeCollapse.transportMode",
      class: "col-md-3 input-form",
      placeHolder: "transportType",
      name: "transportType",
      id: "TransportMode",
    },
    // {
    //   type: "Label",
    //   label: "resume.resumeCollapse.destinationCountry",
    //   class: "col-md-3 input-form",
    //   placeHolder: "destinationCountry",
    //   name: "destinationCountry",
    //   id: "POD",
    // },
    // {
    //   type: "Label",
    //   label: "resume.resumeCollapse.project",
    //   class: "col-md-3 input-form",
    //   placeHolder: "project",
    //   name: "project",
    //   id: "Project",
    // },
    // {
    //   type: "Label",
    //   label: "resume.resumeCollapse.wmsReference",
    //   name: "wmsReference",
    //   class: "col-md-3 input-form",
    //   id: "WMSReference",
    // },
    {
      type: "Label",
      label: "resume.resumeCollapse.clientReference",
      name: "clientReference",
      class: "col-md-3 input-form",
      id: "CustomerReference",
    },
    {
      type: "Label",
      label: "resume.resumeCollapse.buyer",
      name: "buyer",
      class: "col-md-3 input-form",
      id: "Buyer",
    },
    {
      type: "Label",
      label: "resume.resumeCollapse.priorityPO",
      name: "priorityPO",
      class: "col-md-3 input-form",
      id: "PriorityPO",
      boolean: true,
    },
  ],
};

export const TemplatePODetail = {
  titulo: "resume.detailCollapse.title",
  id: "detailOrder",
  edit: [
    {
      type: "Label",
      label: "resume.detailCollapse.qtyOrdered",
      class: "col-md-3 input-form",
      placeHolder: "resume.detailCollapse.qtyOrdered",
      name: "qtyOrdered",
      id: "TotalQTYOrdered",
      isNumber: true,
    },
    {
      type: "Label",
      label: "resume.detailCollapse.qtyConfirmed",
      class: "col-md-3 input-form",
      placeHolder: "resume.detailCollapse.qtyConfirmed",
      name: "qtyConfirmed",
      id: "TotalQTYConfirmed",
      isNumber: true,
    },
    {
      type: "Select",
      label: "resume.detailCollapse.totalQtyUOM",
      class: "col-md-3 input-form",
      placeHolder: "resume.detailCollapse.totalQtyUOM",
      name: "totalQtyUOM",
      // catalogId: "uomCatalogQ",
      // id: "TotalQTYUOM",
      id: "TotalQTYUOMDescription",
      // required: true,
      // catalogFilter: {
      //   key: "Type",
      //   value: "Q",
      // },
    },
    {
      type: "Input",
      label: "resume.detailCollapse.totalPO",
      class: "col-md-3 input-form",
      placeHolder: "resume.detailCollapse.totalPO",
      name: "totalPO",
      id: "OrderValue",
      isNumber: true,
    },
    {
      type: "Input",
      label: "resume.shared.currency",
      class: "col-md-3 input-form",
      placeHolder: "resume.shared.currency",
      name: "currency",
      id: "OrderCurrency",
    },
    {
      type: "Label",
      label: "resume.detailCollapse.totalWeight",
      class: "col-md-3 input-form",
      placeHolder: "resume.detailCollapse.totalWeight",
      name: "totalWeight",
      id: "GrossWeight",
      // required: true,
      isNumber: true,
    },
    {
      type: "Select",
      label: "resume.detailCollapse.totalWeightUOM",
      class: "col-md-3 input-form",
      placeHolder: "resume.detailCollapse.totalWeightUOM",
      name: "totalWeightUOM",
      catalogId: "uomCatalogW",
      id: "GrossWeightUOM",
    },
    {
      type: "Label",
      label: "resume.detailCollapse.netTotalWeight",
      class: "col-md-3 input-form",
      placeHolder: "resume.detailCollapse.netTotalWeight",
      name: "netTotalWeight",
      id: "NetWeight",
      isNumber: true,
    },
    {
      type: "Select",
      label: "resume.detailCollapse.netTotalWeightUOM",
      class: "col-md-3 input-form",
      placeHolder: "resume.detailCollapse.netTotalWeightUOM",
      name: "netTotalWeightUOM",
      catalogId: "uomCatalogW",
      id: "NetWeightUOM",
      catalogFilter: {
        key: "Type",
        value: "W",
      },
    },
    {
      type: "Input",
      label: "resume.detailCollapse.pallets",
      class: "col-md-3 input-form",
      placeHolder: "resume.detailCollapse.pallets",
      name: "pallets",
      id: "NoPallets",
      isNumber: true,
    },
    {
      type: "Input",
      label: "resume.detailCollapse.palletsType",
      class: "col-md-3 input-form",
      placeHolder: "resume.detailCollapse.palletsType",
      name: "palletsType",
      id: "PalletsType",
    },
    {
      type: "Input",
      label: "resume.detailCollapse.poDescription",
      class: "col-md-6 input-form",
      placeHolder: "resume.detailCollapse.poDescription",
      name: "poDescription",
      id: "Description",
    },
    {
      type: "Input",
      label: "resume.detailCollapse.instructions",
      class: "col-md-6 input-form",
      placeHolder: "resume.detailCollapse.instructions",
      name: "instructions",
      id: "SpecialInstructions",
    },
    {
      type: "Input",
      label: "resume.detailCollapse.address",
      class: "col-md-6 input-form",
      placeHolder: "resume.detailCollapse.address",
      name: "address",
      id: "PickupAddress",
    },
    // {
    //   type: "Input",
    //   label: "resume.detailCollapse.deliveryAddressPO",
    //   class: "col-md-6 input-form",
    //   placeHolder: "resume.detailCollapse.deliveryAddressPO",
    //   name: "deliveryAddressPO",
    //   id: "DeliveryAddressPO",
    // },
    // {
    //   type: "Input",
    //   label: "resume.detailCollapse.originZipCode",
    //   class: "col-md-6 input-form",
    //   placeHolder: "resume.detailCollapse.originZipCode",
    //   name: "OriginZipCode",
    //   id: "OriginZipCode",
    //   required: true,
    // },
  ],
  previewForm: [
    {
      type: "Label",
      label: "resume.detailCollapse.qtyOrdered",
      class: "col-md-3 input-form",
      placeHolder: "qtyOrdered",
      name: "qtyOrdered",
      id: "TotalQTYOrdered",
    },
    {
      type: "Label",
      label: "resume.detailCollapse.qtyConfirmed",
      name: "qtyConfirmed",
      class: "col-md-3 input-form",
      id: "TotalQTYConfirmed",
    },
    {
      type: "Label",
      label: "resume.detailCollapse.totalQtyUOM",
      name: "totalQtyUOM",
      class: "col-md-3 input-form",
      id: "TotalQTYUOMDescriptionPO",
    },
    {
      type: "Label",
      label: "resume.detailCollapse.totalPO",
      name: "totalPO",
      class: "col-md-3 input-form",
      id: "OrderValue",
    },
    {
      type: "Label",
      label: "resume.shared.currency",
      name: "currency",
      class: "col-md-3 input-form",
      id: "OrderCurrency",
    },
    {
      type: "Label",
      label: "resume.detailCollapse.totalWeight",
      name: "totalWeight",
      class: "col-md-3 input-form",
      id: "GrossWeightPO",
      format: "weight",
    },
    {
      type: "Label",
      label: "resume.detailCollapse.totalWeightUOM",
      name: "totalWeightUOM",
      class: "col-md-3 input-form",
      id: "GrossWeightUOMDescriptionPO",
    },
    {
      type: "Label",
      label: "resume.detailCollapse.netTotalWeight",
      name: "netTotalWeight",
      class: "col-md-3 input-form",
      id: "NetWeightPO",
      format: "weight",
    },
    {
      type: "Label",
      label: "resume.detailCollapse.netTotalWeightUOM",
      name: "netTotalWeightUOM",
      class: "col-md-3 input-form",
      id: "NetWeightUOMDescriptionPO",
    },
    {
      type: "Label",
      label: "resume.detailCollapse.pallets",
      name: "pallets",
      class: "col-md-3 input-form",
      id: "NoPalletsPO",
    },
    {
      type: "Label",
      label: "resume.detailCollapse.palletsType",
      name: "palletsType",
      class: "col-md-3 input-form",
      id: "PalletsType",
    },
    {
      type: "Label",
      label: "resume.detailCollapse.poDescription",
      name: "poDescription",
      class: "col-md-6 input-form",
      id: "DescriptionPO",
    },
    {
      type: "Label",
      label: "resume.detailCollapse.instructions",
      name: "instructions",
      class: "col-md-6 input-form",
      id: "SpecialInstructions",
    },
    {
      type: "Label",
      label: "resume.detailCollapse.address",
      name: "address",
      class: "col-md-6 input-form",
      id: "pickupAddressConcatenated",
    },
  ],
};

export const ItemDetailResumeForm = {
  titulo: "",
  id: "itemDetailResumeForm",
  edit: [
    {
      type: "Label",
      label: "resume.itemsCollapse.resume.POItemsId",
      class: "col-md-3 input-form",
      placeHolder: "resume.itemsCollapse.resume.POItemsId",
      name: "POItemsId",
      id: "POItemsId",
      // required: true,
    },
    {
      type: "Label",
      label: "resume.shared.qtyOrdered",
      class: "col-md-3 input-form",
      placeHolder: "resume.shared.qtyOrdered",
      name: "qtyOrdered",
      id: "QTYOrdered",
      isNumber: true,
      // required: true,
    },
    {
      type: "Input",
      label: "resume.shared.qtyConfirmed",
      class: "col-md-3 input-form",
      placeHolder: "resume.shared.qtyConfirmed",
      name: "qtyConfirmed",
      isNumber: true,
      id: "QTYConfirmed",
    },
    {
      type: "Select",
      label: "resume.itemsCollapse.resume.uom",
      class: "col-md-3 input-form",
      placeHolder: "resume.itemsCollapse.resume.uom",
      name: "uom",
      id: "UOMCode",
      catalogId: "uomCatalogQ",
      required: true,
    },
    {
      type: "Label",
      label: "resume.itemsCollapse.resume.boxVolume",
      class: "col-md-3 input-form",
      placeHolder: "resume.itemsCollapse.resume.boxVolume",
      name: "boxVolume",
      id: "CaseVolume",
      isNumber: true,
    },
    {
      type: "Label",
      label: "resume.itemsCollapse.resume.boxDescription",
      class: "col-md-3 input-form",
      placeHolder: "resume.itemsCollapse.resume.boxDescription",
      name: "boxDescription",
      id: "CaseDescription",
    },
    {
      type: "Label",
      label: "resume.itemsCollapse.resume.sellerCode",
      class: "col-md-3 input-form",
      placeHolder: "resume.itemsCollapse.resume.sellerCode",
      name: "sellerCode",
      id: "VendorCode",
    },
    {
      type: "Input",
      label: "resume.itemsCollapse.resume.hsCode",
      class: "col-md-3 input-form",
      placeHolder: "resume.itemsCollapse.resume.hsCode",
      name: "hsCode",
      id: "HSCode",
    },
    {
      type: "Input", // falta info
      label: "resume.itemsCollapse.resume.bill",
      class: "col-md-3 input-form",
      placeHolder: "resume.itemsCollapse.resume.bill",
      name: "bill",
      id: "Invoice",
    },
    {
      type: "Label",
      label: "resume.itemsCollapse.resume.priorityItem",
      class: "col-md-3 input-form",
      placeHolder: "resume.itemsCollapse.resume.priorityItem",
      name: "priorityItem",
      id: "PriorityItem",
    },
    {
      type: "Label",
      label: "resume.itemsCollapse.resume.itemValue",
      class: "col-md-3 input-form",
      placeHolder: "resume.itemsCollapse.resume.itemValue",
      name: "itemValue",
      id: "Value",
      isNumber: true,
    },
    {
      type: "Label",
      label: "resume.shared.currency",
      class: "col-md-3 input-form",
      placeHolder: "resume.shared.currency",
      name: "currency",
      id: "Currency",
    },
    {
      type: "Input",
      label: "resume.itemsCollapse.resume.grossWeight",
      class: "col-md-3 input-form",
      placeHolder: "resume.itemsCollapse.resume.grossWeight",
      name: "grossWeight",
      id: "GrossWeight",
      isNumber: true,
    },
    {
      type: "Select",
      label: "resume.itemsCollapse.resume.grossWeightUOM",
      class: "col-md-3 input-form",
      placeHolder: "resume.itemsCollapse.resume.grossWeightUOM",
      name: "grossWeightUOM",
      catalogId: "uomCatalogW",
      id: "GrossWeightUOM",
    },
    {
      type: "Input",
      label: "resume.itemsCollapse.resume.netWeight",
      class: "col-md-3 input-form",
      placeHolder: "resume.itemsCollapse.resume.netWeight",
      name: "netWeight",
      id: "NetWeight",
      isNumber: true,
    },
    {
      type: "Select",
      label: "resume.itemsCollapse.resume.netWeightUOM",
      class: "col-md-3 input-form",
      placeHolder: "resume.itemsCollapse.resume.netWeightUOM",
      name: "netWeightUOM",
      catalogId: "uomCatalogW",
      id: "NetWeightUOM",
    },
    {
      type: "Input",
      label: "resume.itemsCollapse.resume.size",
      class: "col-md-3 input-form",
      placeHolder: "resume.itemsCollapse.resume.size",
      name: "size",
      id: "Size",
    },
  ],
  previewForm: [
    {
      type: "Label",
      label: "resume.itemsCollapse.resume.POItemsId",
      class: "col-md-3 input-form",
      name: "POItemsId",
      id: "POItemsId",
    },
    {
      type: "Label",
      label: "resume.shared.qtyOrdered",
      name: "qtyOrdered",
      class: "col-md-3 input-form",
      id: "QTYOrdered",
    },
    {
      type: "Label",
      label: "resume.shared.qtyConfirmed",
      name: "qtyConfirmed",
      class: "col-md-3 input-form",
      id: "QTYConfirmed",
    },
    {
      type: "Label",
      label: "resume.itemsCollapse.resume.uom",
      class: "col-md-3 input-form",
      name: "uom",
      id: "ItemUOMDescription",
    },
    {
      type: "Label",
      label: "resume.itemsCollapse.resume.boxVolume",
      name: "boxVolume",
      class: "col-md-3 input-form",
      id: "CaseVolume",
      format: "dimension",
    },
    {
      type: "Label",
      label: "resume.itemsCollapse.resume.boxDescription",
      class: "col-md-3 input-form",
      name: "boxDescription",
      id: "CaseDescription",
    },
    {
      type: "Label",
      label: "resume.itemsCollapse.resume.sellerCode",
      name: "sellerCode",
      class: "col-md-3 input-form",
      id: "VendorCode",
    },
    {
      type: "Label",
      label: "resume.itemsCollapse.resume.hsCode",
      class: "col-md-3 input-form",
      name: "hsCode",
      id: "HSCode",
    },
    {
      type: "Label",
      label: "resume.itemsCollapse.resume.bill",
      class: "col-md-3 input-form",
      name: "bill",
      id: "Invoice", //no existe
    },
    {
      type: "Label",
      label: "resume.itemsCollapse.resume.priorityItem",
      class: "col-md-3 input-form",
      name: "priorityItem",
      id: "PriorityItem",
      boolean: true,
    },
    {
      type: "Label",
      label: "resume.itemsCollapse.resume.itemValue",
      name: "itemValue",
      class: "col-md-3 input-form",
      id: "Value",
    },
    {
      type: "Label",
      label: "resume.shared.currency",
      name: "currency",
      class: "col-md-3 input-form",
      id: "Currency",
    },
    {
      type: "Label",
      label: "resume.itemsCollapse.resume.grossWeight",
      name: "grossWeight",
      class: "col-md-3 input-form",
      id: "GrossWeight",
      format: "weight",
    },
    {
      type: "Label",
      label: "resume.itemsCollapse.resume.grossWeightUOM",
      name: "grossWeightUOM",
      class: "col-md-3 input-form",
      id: "ItemGrossWeightUOMDescription",
    },
    {
      type: "Label",
      label: "resume.itemsCollapse.resume.netWeight",
      name: "netWeight",
      class: "col-md-3 input-form",
      id: "NetWeight",
      format: "weight",
    },
    {
      type: "Label",
      label: "resume.itemsCollapse.resume.netWeightUOM",
      name: "netWeightUOM",
      class: "col-md-3 input-form",
      id: "ItemNetWeightUOMDescription",
    },
    {
      type: "Label",
      label: "resume.itemsCollapse.resume.size",
      name: "size",
      class: "col-md-3 input-form",
      id: "Size",
      format: "dimension",
    },
  ],
};

export const ItemDetailResumeFormDates = {
  titulo: "resume.itemsCollapse.resume.Dates.factoryRequested_title",
  id: "itemDetailResumeFormDates",
  edit: [
    {
      type: "Label",
      label: "resume.itemsCollapse.resume.Dates.factoryRequested",
      format: "DD-MM-YYYY",
      name: "factoryRequested",
      class: "col-md-3 input-form",
      placeHolder: "resume.itemsCollapse.resume.Dates.factoryRequested",
      id: "RequestedExWorks",
    },
    {
      type: "Label",
      label: "resume.shared.uploadRequest",
      format: "DD-MM-YYYY",
      name: "factoryRequested",
      class: "col-md-3 input-form",
      placeHolder: "resume.shared.uploadRequest",
      id: "RequiredCagoReady",
    },
    {
      type: "Date",
      label: "resume.itemsCollapse.resume.Dates.promiseUploadRequest",
      format: "DD-MM-YYYY",
      name: "promiseUploadRequest",
      class: "col-md-3 input-form",
      placeHolder: "resume.itemsCollapse.resume.Dates.promiseUploadRequest",
      id: "PromiseCargoReady",
    },
    {
      type: "Date",
      label: "resume.itemsCollapse.resume.Dates.realUploadRequest",
      format: "DD-MM-YYYY",
      name: "realUploadRequest",
      class: "col-md-3 input-form",
      placeHolder: "resume.itemsCollapse.resume.Dates.realUploadRequest",
      id: "ActualCargoReady",
    },
    // {
    //   type: "Date",
    //   label: "resume.itemsCollapse.resume.Dates.estimatePickup",
    //   format: "DD-MM-YYYY",
    //   name: "estimatePickup",
    //   class: "col-md-3 input-form",
    //   placeHolder: "resume.itemsCollapse.resume.Dates.estimatePickup",
    //   id: "EstimatedPickedUp",
    // },
    // {
    //   type: "Label",
    //   label: "resume.itemsCollapse.resume.Dates.RealPickup",
    //   format: "DD-MM-YYYY",
    //   name: "RealPickup",
    //   class: "col-md-3 input-form",
    //   placeHolder: "resume.itemsCollapse.resume.Dates.RealPickup",
    //   id: "ActualCargoPickup",
    // },
  ],
  previewForm: [
    {
      type: "Label",
      label: "resume.itemsCollapse.resume.Dates.factoryRequested",
      format: "DD-MM-YYYY",
      class: "col-md-3 input-form",
      name: "factoryRequested",
      id: "RequestedExWorks",
    },
    {
      type: "Label",
      label: "resume.shared.uploadRequest",
      format: "DD-MM-YYYY",
      class: "col-md-3 input-form",
      name: "uploadRequest",
      id: "RequiredCagoReady",
    },
    {
      type: "Label",
      label: "resume.itemsCollapse.resume.Dates.promiseUploadRequest",
      format: "DD-MM-YYYY",
      class: "col-md-3 input-form",
      name: "promiseUploadRequest",
      id: "PromiseCargoReady",
    },
    {
      type: "Label",
      label: "resume.itemsCollapse.resume.Dates.realUploadRequest",
      format: "DD-MM-YYYY",
      class: "col-md-3 input-form",
      name: "realUploadRequest",
      id: "ActualCargoReady",
    },
    // {
    //   type: "Label",
    //   label: "resume.itemsCollapse.resume.Dates.estimatePickup",
    //   format: "DD-MM-YYYY",
    //   class: "col-md-3 input-form",
    //   name: "estimatePickup",
    //   id: "EstimatedPickedUp",
    // },
    // {
    //   type: "Label",
    //   label: "resume.itemsCollapse.resume.Dates.RealPickup",
    //   format: "DD-MM-YYYY",
    //   class: "col-md-3 input-form",
    //   name: "RealPickup",
    //   id: "ActualCargoPickup",
    // },
  ],
};
